module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-GB":{"delete-product":"Delete Product","product-deleted":"Product deleted","failed-delete-product":"Failed to delete product"}}')
  delete Component.options._Ctor
}
